import React from "react";
import tecnology from "../assets/img/tecnology.jpeg";
import about from "../assets/img/about-us-banner-1.jpg";
import services from "../assets/img/services.png";
import clients from "../assets/img/clients.jpg";
import events from "../assets/img/events.jpg";
import contact from "../assets/img/contact3.jpg";

const Carousel = () => {
  const slides = [
    {
      image: tecnology,
      title: "Welcome to YOD Business Solution",
      text: "YOD delivers cutting-edge software and integrated business solutions designed to meet the unique needs of the diverse commercial landscape across Africa. We blend unparalleled local knowledge with international standards to create effective solutions",
      link: "/",
    },
    {
      image: about,
      title: "About YOD",
      text: "YOD Business Solution is envisioned to be Africa's leading provider of effective business solutions. We are committed to empowering businesses with innovative tools and strategies that streamline operations and drive success.",
      link: "/about",
    },
    {
      image: services,
      title: "Our Services",
      text: "We offer ERP systems that transform how businesses operate by integrating and streamlining finance, HR, supply chain, and production. Centralized data = informed decisions.",
      link: "/services",
    },
    {
      image: clients,
      title: "Our Clients",
      text: "Our clients are the cornerstone of our success. We build lasting partnerships and help them achieve growth milestones.",
      link: "#",
    },
    {
      image: events,
      title: "News & Events",
      text: "Stay connected with our milestones, events, and breakthroughs. Get the latest updates from YOD Business Solution.",
      link: "#",
    },
    {
      image: contact,
      title: "Contact Us",
      text: "We're just a click away. Reach out with questions, support, or collaboration ideas. Let's bring your vision to life.",
      link: "/contact",
    },
  ];

  return (
    <div className="container-fluid p-0">
      <div id="carouselId" className="carousel slide" data-bs-ride="carousel">
        {/* Indicators */}
        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselId"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        {/* Slides */}
        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              style={{ height: "100vh", minHeight: "600px" }}
            >
              <img
                src={slide.image}
                className="d-block w-100 h-100"
                alt={slide.title}
                style={{ objectFit: "cover", filter: "brightness(0.5)" }}
              />
              <div className="carousel-caption d-flex flex-column justify-content-center align-items-center h-100">
                <div
                  className="text-center p-4"
                  style={{ maxWidth: "900px" }}
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <h1 className="display-3 fw-bold text-white mb-4">
                    {slide.title}
                  </h1>
                  <p
                    className="text-white fs-5 mb-4"
                    data-aos="fade-up"
                    data-aos-delay="500"
                  >
                    {slide.text}
                  </p>
                  <a
                    className="btn rounded-pill text-white py-3 px-5"
                    href={slide.link}
                    style={{ backgroundColor: "#A71717" }}
                    data-aos="fade-up"
                    data-aos-delay="700"
                  >
                    More Details
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselId"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            style={{ backgroundColor: "#A71717", borderRadius: "50%" }}
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselId"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            style={{ backgroundColor: "#A71717", borderRadius: "50%" }}
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default Carousel;
